import {
  Activity,
  BookOpen,
  Bot,
  Building2,
  Calculator,
  Calendar,
  CalendarClock,
  Check,
  FileSignature,
  FileText,
  Gauge,
  GraduationCap,
  LifeBuoy,
  ListChecks,
  Mail,
  MessagesSquare,
  Plug,
  Rocket,
  ShieldCheck,
  Sparkles,
  Upload,
  Workflow,
  type LucideIcon,
} from "lucide-react";
import type { ComponentProps } from "react";

// Friendly string keys -> lucide icon components. Keeping icons keyed by
// string lets the docs nav config (`_config.ts`) and the MDX `<Card>`
// component reference icons by name, so content authors never import a
// component to pick one. Add a key here before using it in config/MDX.
export const DOCS_ICONS = {
  // sections
  "getting-started": Rocket,
  agents: Bot,
  connect: Plug,
  optimize: Sparkles,
  help: LifeBuoy,
  // general
  book: BookOpen,
  check: Check,
  activity: Activity,
  checklist: ListChecks,
  shield: ShieldCheck,
  learn: GraduationCap,
  chat: MessagesSquare,
  dashboard: Gauge,
  upload: Upload,
  workflow: Workflow,
  doc: FileText,
  // integrations
  gmail: Mail,
  "google-calendar": Calendar,
  slack: MessagesSquare,
  calendly: CalendarClock,
  hubspot: Building2,
  docusign: FileSignature,
  quickbooks: Calculator,
} satisfies Record<string, LucideIcon>;

export type DocIconName = keyof typeof DOCS_ICONS;

/**
 * Renders a docs icon by name. Resolving via member access on the static
 * `DOCS_ICONS` map (rather than returning the component from a helper)
 * keeps the icon reference stable across renders. Returns null for an
 * unknown name, so callers can render it unconditionally.
 */
export function DocIcon({
  name,
  ...props
}: { name?: string } & ComponentProps<LucideIcon>) {
  const Icon = name
    ? (DOCS_ICONS as Record<string, LucideIcon>)[name]
    : undefined;
  return Icon ? <Icon {...props} /> : null;
}
